import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import packaging from './packagingReducer';
import layout from './layoutReducer';
import carrier from './carrierReducer';
import property from './propertyReducer';
import configuration from './configurationReducer';
import user from './userReducer';
import packages from './packageReducer';
import template from './templateReducer';
import partner from './partnerReducer';
import reseller from './resellerReducer';
import history from './historyReducer';
import cost from './costReducer';
import segment from './segmentReducer';
import productGroup from './productGroupReducer';
import discount from './discountReducer';
import promotion from './promotionReducer';
import translation from './translationReducer';
import imports from './importReducer';
import customer from './customerReducer';
import order from './orderReducer';
import quote from './quoteReducer';
import forms from './formReducer';
import rollIn from './rollInReducer';
import rollOut from './rollOutReducer';
import formVersion from './formVersionReducer';
import machine from './machineReducer';
import jobResult from './jobResultReducer';
import coatingIn from './coatingInReducer';
import coatingOut from './coatingOutReducer';
import planning from './planningReducer';
import jobs from './jobReducer';
import reprint from './reprintReducer';
import errors from './errorsReducer';
import orderItem from './orderItemReducer';
import designLibrary from './designLibraryReducer';
import logistic from './logisticReducer';
import box from './boxReducer';
import emailTemplate from './emailTemplateReducer';
import shippingType from './shippingTypeReducer';
import paymentType from './paymentTypeReducer';
import stores from './storeReducer';
import accountancy from './accountancyReducer';
import statistics from './statisticReducer';

const reducers = combineReducers({
    layout,
    carrier,
    property,
    configuration,
    user,
    packages,
    template,
    partner,
    reseller,
    history,
    cost,
    segment,
    productGroup,
    discount,
    promotion,
    translation,
    imports,
    customer,
    order,
    quote,
    forms,
    rollIn,
    rollOut,
    formVersion,
    jobResult,
    packaging,
    machine,
    coatingIn,
    coatingOut,
    planning,
    jobs,
    reprint,
    errors,
    orderItem,
    designLibrary,
    logistic,
    box,
    emailTemplate,
    shippingType,
    paymentType,
    stores,
    accountancy,
    statistics,
    form: formReducer,
});

export default reducers;
